import axios from 'axios';
import type { AxiosResponse, AxiosError } from 'axios';
import { toast } from 'react-toastify';

import { logoutAction } from '@/app/[subdomain]/(main)/_components/account-menu/logout-action';

export const clientInstance = axios.create({
  withCredentials: true,
  baseURL: '/api'
});

const ERROR_MESSAGE = 'Session expired. Please login again.';

const handleSuccessResponse = (response: AxiosResponse) => {
  return response;
};

const handleUnauthorizedResponse = async (error: AxiosError) => {
  if (error.response?.status === 401) {
    toast.error(ERROR_MESSAGE, { toastId: error.response.status });
    await logoutAction();
  }
  return Promise.reject(error);
};

clientInstance.interceptors.response.use(handleSuccessResponse, handleUnauthorizedResponse);
